import apiUtils from '../apiUtils';

const service = {};
const serviceName = 'logout';

service.post = () => {
  return apiUtils.exec(serviceName + '/', apiUtils.getFetchParameters('POST'));
};

export default service;